import {
  GREET_UPLOAD_VIDEO,
  GREET_RECORD_NOW,
  GREET_RECORD_START,
  GREET_RECORD_STOP,
  GREET_RECORD_SETTINGS,
  GREET_RECORD_SETTINGS_CLOSE,
  GREET_RECORD_REPLAY,
  GREET_THUMBNAIL_SELECT,
  GREET_THUMBNAIL_CONFIRM,
  GREET_TEMPLATE_SELECT,
  GREET_CONFIRM_SEND,
  GREET_RECORD_DISCARD,
} from '~/generated/AnalyticsTypes';
import { Greet } from '~/types/models';
import analytics from '~/utils/Analytics';
import { EmailLayout } from '../Modules/Settings/MessageTemplates/Types';

export type GreetEvent =
  | typeof GREET_UPLOAD_VIDEO
  | typeof GREET_RECORD_NOW
  | typeof GREET_RECORD_START
  | typeof GREET_RECORD_STOP
  | typeof GREET_RECORD_SETTINGS
  | typeof GREET_RECORD_SETTINGS_CLOSE
  | typeof GREET_RECORD_REPLAY
  | typeof GREET_THUMBNAIL_SELECT
  | typeof GREET_THUMBNAIL_CONFIRM
  | typeof GREET_TEMPLATE_SELECT
  | typeof GREET_CONFIRM_SEND
  | typeof GREET_RECORD_DISCARD;

interface GreetRecordSettingsData {
  videoDevice?: string | null;
  audioDevice?: string | null;
}

export function trackGreetEvent(
  event: Exclude<
    GreetEvent,
    | typeof GREET_RECORD_STOP
    | typeof GREET_RECORD_SETTINGS
    | typeof GREET_RECORD_SETTINGS_CLOSE
  >,
  greet: Greet,
  extraData?: never
): void;
export function trackGreetEvent(
  event: typeof GREET_RECORD_STOP,
  greet: Greet,
  extraData: { videoDuration?: number }
): void;
export function trackGreetEvent(
  event: typeof GREET_RECORD_SETTINGS | typeof GREET_RECORD_SETTINGS_CLOSE,
  greet: Greet,
  extraData: GreetRecordSettingsData
): void;
export function trackGreetEvent(
  event: typeof GREET_TEMPLATE_SELECT,
  greet: Greet,
  extraData: { email_layout: EmailLayout }
): void;
export function trackGreetEvent(
  event: typeof GREET_CONFIRM_SEND,
  greet: Greet,
  extraData: {
    isOptimisedSending?: boolean;
    isManualScheduled?: boolean;
  }
): void;
export function trackGreetEvent<T = never>(
  event: GreetEvent,
  greet: Greet,
  extraData?: T
) {
  analytics.track(event, {
    greetId: greet.id,
    source: 'web',
    platform: navigator.platform,
    greetType: greet.greet_type,
    templateType: greet.message_template?.template_type,
    sourceCreatedBy: greet.metadata?.source_created_by,
    deliveryType: greet.metadata?.delivery_type,
    ...(extraData ?? {}),
  });
}
